"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Switch_1 = __importDefault(require("@material-ui/core/Switch"));
const themeColors_1 = require("../../theme/themeColors");
const { primaryColor } = themeColors_1.themeColors;
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    root: {
        width: ({ size }) => (size * 2 + 4),
        height: ({ size }) => (size + 4),
        padding: 0,
    },
    switchBase: {
        padding: 2,
        color: theme.palette.grey[200],
        '&$checked': {
            color: theme.palette.common.white,
            transform: 'translateX(80%)',
            '& + $track': {
                backgroundColor: primaryColor,
                borderColor: primaryColor,
            },
        },
        '&:not(.Mui-disabled)': {
            '& + $track': {
                opacity: 1,
            },
        },
        '&.Mui-disabled': {
            '& + $track': {
                opacity: 0.5,
            },
        },
    },
    thumb: {
        width: ({ size }) => size,
        height: ({ size }) => size,
        boxShadow: 'none',
    },
    track: {
        border: `1px solid ${theme.palette.grey[500]}`,
        borderRadius: ({ size }) => (size + 4) / 2,
        opacity: 1,
        backgroundColor: '#9B9B9B',
    },
    checked: {},
}));
const AntSwitch = (0, react_1.memo)(({ size = 12, required = false, disabled = false, checked, onChange, }) => {
    const classes = useStyles({ size });
    return react_1.default.createElement(Switch_1.default, { classes: classes, required: required, disabled: disabled, checked: checked, onChange: onChange });
});
exports.default = AntSwitch;
//# sourceMappingURL=ant-switch.js.map